module.exports = __webpack_public_path__ + "img/bl-big-01.f0d3041b.jpg";